<template>
      <div>
        <!-- Consultation or Past Consultation -->
        <div>
            <div id="consultation-container" class="d-flex flex-column">
                <!-- Details -->
                <div id="consultation-details" class="d-flex align-items-baseline">
                    <div class="mr-3">
                        <b>Name:</b> {{consultation.participantName}}
                    </div>
                    <div class="mr-3">
                        Gender: {{consultation.patientGender}}
                    </div>
                    <div>
                        Age: {{consultation.patientAge > -1 ? consultation.patientAge : 'Not Specified'}}
                    </div>
                    <!-- <div class="ml-auto">
                        {{consultation.startTime ? convertToUserReadableDateTime(consultation.startTime) : '-'}}
                    </div>
                    <div v-if="isConsultationInProgress">
                        <button class="btn btn-primary btn-primary-insv ml-4">Past Consultations</button>
                    </div> -->
                    <ul class="nav nav-tabs nav-tabs-nowrap ml-auto" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a v-if="isConsultationInProgress" class="nav-link active text-danger" id="consultation-details-tab" data-toggle="tab" href="#consultationDetails" role="tab">Current Consultation</a>
                            <button v-if="$route.query.newTab" class="btn btn-danger btn-danger-insv mb-2 mr-2" @click="closeWindow()">Close</button>
                        </li>
                        <li v-if="isConsultationInProgress" class="nav-item">
                            <a class="nav-link" id="consultation-histories-tab" data-toggle="tab" href="#consultationHistories" role="tab">Previous Consultations
                                <span class="ml-1 badge" :class="{
                                    'badge-primary': consultationList.length > 0,
                                    'badge-secondary':   consultationList.length === 0,
                                }">
                                    {{ consultationList.length}}
                                </span>
                            </a>
                        </li>
                        <li v-if="isConsultationInProgress" class="nav-item">
                            <a class="nav-link" id="medical-reports-tab" data-toggle="tab" href="#medicalReports" role="tab">Medical Reports
                                <span class="ml-1 badge" :class="{
                                    'badge-primary': uploadedReports.length > 0,
                                    'badge-secondary': uploadedReports.length === 0,
                                }">
                                    {{uploadedReports.length}}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>

                <!-- Fields -->
                <div class="tab-content h-100" id="myTabContent">
                    <div class="tab-pane fade show active h-100" id="consultationDetails" role="tabpanel">
                        <div id="consultation-fields" class="flex-grow-1 d-flex h-100">
                            <!-- First column -->
                            <div id="first-col-wrapper" class="d-flex flex-column flex-grow-1 overflow-auto">

                                <!-- Section 1 -->
                                <div id="section-1" class="flex-grow-1 d-flex flex-column">
                                    <div class="d-flex justify-content-between">
                                        <p class="mb-2"><b>Notes</b></p>
                                        <i class="fa fa-search search-icon"></i>
                                    </div>
                                    <div class="d-flex flex-grow-1">
                                        <div class="mr-2">
                                            <label class="label">Family History:</label>
                                        </div>
                                        <div class="flex-grow-1">
                                            <textarea :disabled="!isConsultationInProgress" v-model="form.fh" rows="2" type="text" class="form-control"/>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-grow-1">
                                        <div class="mr-2">
                                            <label class="label">Allergies:</label>
                                        </div>
                                        <div class="flex-grow-1">
                                            <textarea :disabled="!isConsultationInProgress" v-model="form.dal" rows="2" type="text" class="form-control"/>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-grow-1">
                                        <div class="mr-2">
                                            <label class="label">Medical History:</label>
                                        </div>
                                        <div class="flex-grow-1">
                                            <textarea :disabled="!isConsultationInProgress" v-model="form.pai" rows="4" type="text" class="form-control"/>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-grow-1">
                                        <div class="mr-2">
                                            <label class="label">Special Remarks:</label>
                                        </div>
                                        <div class="flex-grow-1">
                                            <textarea :disabled="!isConsultationInProgress" v-model="form.sr" rows="4" type="text" class="form-control"/>
                                        </div>
                                    </div>
                                </div>

                                <!-- Section 2 -->
                                <div id="section-2" class="flex-grow-1 d-flex flex-column justify-content-between">
                                    <div class="d-flex flex-column justify-content-between">
                                        <div>
                                            <div class="d-flex justify-content-between">
                                                <p class="mb-2"><b>Physical Examination</b></p>
                                                <i class="fa fa-search search-icon"></i>
                                            </div>
                                            <div class="d-flex flex-column justify-content-between mb-3">
                                                <div class="d-flex">
                                                    <div class="mr-2">
                                                        <label class="label">Findings:</label>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <textarea :disabled="!isConsultationInProgress" v-model="form.f" rows="4" type="text" class="form-control"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <p class="mb-1"><b>ICD Codes</b></p>
                                            <i class="fa fa-search search-icon"></i>
                                        </div>
                                        <div v-if="isConsultationInProgress">
                                            <icd-codes :isEdit="true" v-model="form.icdCodes"></icd-codes>
                                        </div>
                                        <div v-else>
                                            <p v-if="assignedIcdCodes.length === 0" class="font-italic">
                                                No assigned ICD 10 Codes.
                                            </p>

                                            <p v-else v-for="(icd, index) in assignedIcdCodes" :key="index">
                                                <b>{{ icd.code }}</b> - {{ icd.description }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column align-items-center" v-if="isConsultationInProgress">
                                        <p v-show="saveErrorMessage" class="text-danger mb-3">{{saveErrorMessage}}</p>
                                        <div>
                                            <button class="btn btn-primary btn-primary-insv mr-2" type="button" @click="endSession">
                                                Save and End Session
                                            </button>
                                            <router-link :to="{
                                                'name': 'doctor-consultation-list',
                                                }" class="btn btn-secondary">
                                                Back to Consultation List
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Second column -->
                            <div id="second-col-wrapper" class="d-flex flex-column flex-grow-1">

                                <!-- Section 3 -->
                                <div id="section-3" class="flex-grow-1 overflow-auto d-flex flex-column">
                                    <div class="d-flex justify-content-between">
                                        <p class="mb-2"><b>Medicine</b></p>
                                        <i class="fa fa-search search-icon"></i>
                                    </div>
                                    <prescription-detail :isEdit="isConsultationInProgress" v-model="form.prescriptionList"
                                        :pharmacyId="form.pharmacyId">
                                        <template v-if="form.prescriptionList.length> 0">
                                                <form data-vv-scope="prescription-valid-days" @submit.prevent="validatePrescriptionValidDays">
                                                    <div id="prescription" class="d-flex align-items-baseline">
                                                        <label class="mr-2 mb-0">{{ isConsultationInProgress ? "Prescription Valid for (Days):" : "Prescription valid until"}}  </label>
                                                        <input name="prescriptionValidDays" type="text"
                                                            v-if="isConsultationInProgress"
                                                            data-vv-validate-on="blur" data-vv-as="prescription valid"
                                                            v-validate="'required|numeric|min_value:1'"
                                                            v-model="form.prescriptionValidDays" :class="{
                                                            'form-control': true,
                                                            'is-invalid':  validationErrors.has('prescription-valid-days.prescriptionValidDays')
                                                        }">
                                                        <div v-else>
                                                            {{prescription.validUntil ? convertToUserReadableDate(prescription.validUntil): '-'}}
                                                        </div>
                                                    </div>
                                                </form>
                                        </template>
                                    </prescription-detail>
                                </div>

                                <!-- Section 4 -->
                                <div id="section-4" v-if="isConsultationInProgress" class="d-flex flex-column flex-grow-1">
                                <!-- <div id="section-4" class="flex-grow-1 d-flex flex-column"> -->
                                    <div>
                                        <p class="mb-1"><b>Video Call</b></p>
                                    </div>
                                    <div class="d-flex flex-column" style="flex: 1 1 0%;">
                                        <!-- <twilio-video ref="twilioVideo" :twilioToken="this.twilioToken"
                                            :twilioRoomName="this.twilioRoomName" :loading.sync="isTwilioLoading"
                                            :started.sync="isTwilioStarted" :joined.sync="isTwilioJoined"
                                            :statusText.sync="twilioStatus" :startText="startVideoText" :waitingText="waitingVideoText"
                                            :isEnded.sync="isVideoCallEnded"
                                            :isDoctor="true">
                                        </twilio-video> -->

                                        <zoomVideo ref="zoomVideo" :token="zoomToken" :participantName="zoomParticipantName" :sessionName="zoomSessionName"
                                            :sessionKey="zoomSessionKey" @connected="onZoomConnected" @ended="onZoomEnded" @userConnected="onZoomUserConnected">
                                        </zoomVideo>
                                    </div>
                                    <div>
                                        <p>{{zoomStatus}}</p>
                                        <template v-if="!zoomEnded">
                                        <button v-show="!zoomConnected" class="btn btn-primary btn-primary-insv"
                                            @click="startVideoCall">Start
                                            Video Call Session</button>
                                        <button v-show="zoomConnected" class="btn btn-danger"
                                            @click="endVideoCall">End Video Call Session
                                        </button>
                                    </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="consultationHistories" role="tabpanel">
                        <div class="tab-content-wrapper">
                            <template v-if="consent.isAllowedViewConsultationHistories">
                                <h5 class="mb-3">Consultation Histories</h5>

                                <div>
                                    <div class="table-responsive">
                                        <table class="table table-hover">
                                            <colgroup>
                                                <col width="40">
                                                <col width="140">
                                                <col width="140">
                                                <col>
                                                <col width="400">
                                                <col width="250">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Time</th>
                                                    <th scope="col">Doctor Name</th>
                                                    <th scope="col">ICD Codes</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr v-show="consultationList.length === 0">
                                                    <td colspan="5" class="text-center font-italic">
                                                        No Data
                                                    </td>
                                                </tr>
                                                <tr v-for="(consultation, index) in consultationList" :key="index">
                                                    <th scope="row">{{index+1}}</th>
                                                    <td class="text-nowrap">{{consultation.date}}</td>
                                                    <td class="text-nowrap">
                                                        {{consultation.time}}
                                                    </td>
                                                    <td>{{consultation.doctorName}}</td>
                                                    <td>
                                                        <template v-if="consultation.icd.length === 0">-</template>
                                                        <template v-else>
                                                            <div class="text-nowrap">
                                                                <div class="d-flex mb-1" v-for="(code, index) in consultation.icd" :key="index">
                                                                    <span class="badge text-nowrap badge-success mr-2">
                                                                        {{ code.c }}
                                                                    </span>
                                                                    <div class="text-truncate" style="max-width: 300px;" :title="code.d">
                                                                        {{ code.d }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </td>
                                                    <td>
                                                        <router-link :to="{
                                                            'name': getConsultationLink(consultation.type),
                                                            'params': {
                                                                'id': consultation.id
                                                            },
                                                            'query': {
                                                                'newTab': true
                                                            }
                                                        }"
                                                        target="_blank">
                                                            View Details
                                                        </router-link>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </template>
                            <div v-else>
                                <p>Patient doesn't allow viewing of previous consultations.</p>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="medicalReports" role="tabpanel">
                        <div class="tab-content-wrapper">
                            <template v-if="consent.isAllowedViewMedicalReports">
                                <h5 class="mb-3">Medical Reports</h5>
                                <table ref="listTable2" class="table table-hover">
                                    <colgroup>
                                        <col width="40">
                                        <col width="200">
                                        <col>
                                        <col width="250">
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Upload Date</th>
                                            <th scope="col">Report Type</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-show="uploadedReports.length === 0">
                                            <td colspan="4" class="text-center font-italic">
                                                No Data
                                            </td>
                                        </tr>
                                        <tr v-for="(report, index) in uploadedReports" :key="index">
                                            <th scope="row">{{index+1}}</th>
                                            <td class="text-nowrap">{{report.date}}</td>
                                            <td class="text-nowrap">{{report.reportType}}</td>
                                            <td class="text-nowrap">
                                                <router-link :to="{'name': 'doctor-medical-report-detail' , 'params': {'id': report.reportId}}" target="_blank">View Report</router-link>
                                                <!-- <a :href="`${apiPath}MedicalReport/DownloadReportById?reportId=${report.reportId}`" target="_blank">Download Report</a> -->
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>
                            <div v-else>
                                <p>Patient doesn't allow viewing of the medical reports.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="End Session">
                <template slot="content">
                    <p>{{confirmationMessage}}</p>
                </template>
                <template slot="footer">
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="saveAndEndSession">Save and End Session</button>
                    <button type="button" class="btn btn-secondary" @click="dismissEndSession">Cancel</button>
                </template>
            </popup-modal>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';
import {
    replaceLineBreakInHtml,
    convertToUserReadableDate,
    constructPrescriptionList
} from '@/utilities';
import icdCodes from '@/components/icd-codes';
import prescriptionDetail from '@/components/prescription';
import appointmentDetail from '@/components/appointment-detail';
import twilioVideo from '@/components/twilio-video';
import zoomVideo from '@/components/zoom-video';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'DoctorConsultationDetails',
    'components': {
        icdCodes,
        appointmentDetail,
        prescriptionDetail,
        twilioVideo,
        popupModal,
        zoomVideo
    },
    'computed': {
        consultationId () {
            return this.$route.params.id;
        },
        isConsultationInProgress () {
            return this.consultationStatus === 2;
        },
        prescriptionSpecialReminder () {
            return this.form.prescriptionSpecialReminder ? replaceLineBreakInHtml(this.form
                .prescriptionSpecialReminder) : 'NIL';
        },
        bmi () {
            if (this.form.w && this.form.h) {
                return (this.form.w / ((this.form.h / 100) * (this.form.h / 100))).toFixed(2);
            }

            return null;
        }
    },
    data () {
        return {
            convertToUserReadableDate,
            replaceLineBreakInHtml,
            'form': {
                'fh': null,
                'sr': null,
                't': null,
                'bps': null,
                'bpd': null,
                'pr': null,
                'sl': null,
                'w': null,
                'h': null,
                'f': null,
                'a': null,
                'da': null,
                'ea': null,
                'la': null,
                'm': null,
                'ai': null,
                'c': null,
                'dal': null,
                'pai': null,
                'cm': null,
                'prescriptionList': [],
                'prescriptionValidDays': 0,
                'prescriptionSpecialReminder': null,
                'icdCodes': [],
                'pharmacyId': null
            },
            'prescription': {
                'validUntil': ''
            },
            'consultation': {
                'startTime': null,
                'consultationId': null,
                'participantName': null,
                'doctorName': null,
                'patientGender': '',
                'patientAge': '-1',
                'patientContact': '',
                'patientEmail': ''
            },
            'consultationStatus': 0,
            'twilioToken': null,
            'twilioRoomName': null,
            'isTwilioLoading': true,
            'isTwilioStarted': false,
            'isTwilioJoined': false,
            'twilioStatus': null,
            'startVideoText': 'Please click "Start Video Call Session" to make video call.',
            'waitingVideoText': 'Waiting for patient to connect...',
            'isVideoCallEnded': false,
            'confirmationMessage': null,
            'saveErrorMessage': null,
            'consent': {
                'userId': '',
                'sessionId': '',
                'isAllowedViewConsultationHistories': false,
                'isAllowedViewMedicalReports': false
            },
            'consultationList': [],
            'uploadedReports': [],
            'assignedIcdCodes': [],
            'zoomToken': '',
            'zoomParticipantName': '',
            'zoomSessionName': '',
            'zoomSessionKey': '',
            'zoomConnected': false,
            'zoomEnded': false,
            'zoomStatus': 'Please click on "Start Video Call Session" to initiate the video call.'
        };
    },
    mounted () {
        let id = this.$route.params.id;

        if (id) {
            this.axios.get('Consultation/GetConsultationDetails', {
                'params': {
                    'consultationId': id
                }
            }).then(({
                data
            }) => {
                let consultation = data.data;

                this.consultation.startTime = consultation.st;
                this.consultation.consultationId = consultation.cis;
                this.consultation.participantName = consultation.u ? consultation.u.fn : null;
                this.consultation.doctorName = consultation.d ? consultation.d.n : null;
                this.consultation.patientGender = consultation.u ? consultation.u.g : null;
                this.consultation.patientAge = consultation.u ? consultation.u.a : -1;
                this.consultation.patientContact = consultation.u ? consultation.u.pn : null;
                this.consultation.patientEmail = consultation.u ? consultation.u.e : null;

                this.form.dal = consultation.dal;
                this.form.pai = consultation.pai;
                this.form.fh = consultation.fh;
                this.form.sr = consultation.sr;
                this.form.t = 0;
                this.form.bps = 0;
                this.form.bpd = 0;
                this.form.pr = 0;
                this.form.sl = 0;
                this.form.w = 0;
                this.form.h = 0;
                this.form.f = consultation.f;
                this.form.a = '';

                this.consultationStatus = consultation.cs;

                this.consent.userId = consultation.ui;
                this.consent.sessionId = consultation.ai;

                this.form.pharmacyId = consultation.phid;

                this.initializePrescriptionList(consultation.p);
                this.consentViewConsultationHistories();
                this.consentViewMedicalReports();

                if (consultation.icds) {
                    this.assignedIcdCodes = consultation.icds.map((icd) => {
                        return {
                            'code': icd.c,
                            'description': icd.d
                        };
                    });
                }
            }).catch(() => { });
        }

        // Add class to page-content and page-container to remove padding
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.add('consultation');
        const pageContainer = document.getElementsByClassName('page-container');
        pageContainer[0].classList.add('consultation');

        // Init Tooltips
        $('[data-toggle="tooltip"]').tooltip();
    },
    destroyed () {
        const pageContent = document.getElementsByClassName('page-content');
        pageContent[0].classList.remove('consultation');
        const pageContainer = document.getElementsByClassName('page-container');
        pageContainer[0].classList.remove('consultation');
    },
    'methods': {
        initializePrescriptionList (prescription) {
            if (prescription && prescription.pil) {
                this.form.prescriptionList = constructPrescriptionList(prescription.pil);
            }

            if (prescription && prescription.vu) {
                this.prescription.validUntil = prescription.vu;
            }

            if (prescription && prescription.sr) {
                this.form.prescriptionSpecialReminder = prescription.sr;
            }
        },
        endSession () {
            this.validatePrescriptionValidDays().then((valid) => {
                if (valid) {
                    this.saveErrorMessage = '';
                    this.confirmationMessage = 'Are you sure you want to end this session?';
                    this.$refs.popupModalConfirmation.show();
                } else {
                    this.saveErrorMessage =
                            'You have error(s) in the form. Please check the input(s) before saving...';
                    this.$nextTick(() => {
                        let errorInput = document.querySelector('.is-invalid');

                        if (errorInput) {
                            errorInput.focus();
                        }
                    });
                }
            });
        },
        dismissEndSession () {
            this.$refs.popupModalConfirmation.hide();
        },
        saveAndEndSession () {
            this.confirmationMessage = 'Saving consultation data...';

            let prescriptionList = [];
            prescriptionList = this.form.prescriptionList.map((item) => ({
                'di': item.drugId,
                'q': item.quantity,
                'fd': item.consumptionFrequency,
                'qc': item.quantityPerConsumption,
                'si': null,
                'sr': null,
                'ii': item.intakeInstruction
            }));

            this.endVideoCall();

            let prescriptionDetails = prescriptionList.length === 0 ? null : {
                'pl': prescriptionList,
                'pvd': this.form.prescriptionValidDays,
                'sr': this.form.prescriptionSpecialReminder
            };

            this.axios.post('Consultation/EndSession', {
                'ci': this.consultationId,
                'da': this.form.da,
                'ea': this.form.ea,
                'la': this.form.la,
                'pi': this.form.pharmacyId,
                'm': this.form.m,
                'c': this.form.c,
                'dal': this.form.dal,
                'pai': this.form.pai,
                'fh': this.form.fh,
                'sr': this.form.sr,
                't': this.form.t,
                'bps': this.form.bps,
                'bpd': this.form.bpd,
                'pr': this.form.pr,
                'sl': this.form.sl,
                'w': this.form.w,
                'h': this.form.h,
                'f': this.form.f,
                'a': this.form.a,
                'icd': this.form.icdCodes,
                'pd': prescriptionDetails
            }).then(({
                data
            }) => {
                this.$refs.popupModalConfirmation.hide();
                this.$router.push({
                    'name': 'doctor-consultation-list'
                });
            }).catch((error) => {
                if (error && error.response) {
                    if (error.response.data) {
                        this.confirmationMessage = error.response.data.message;
                    } else {
                        this.confirmationMessage =
                                    'Error saving consultation, please try again.';
                    }
                } else {
                    this.confirmationMessage =
                                    'Error saving consultation, please try again.';
                }
            });
        },
        startVideoCall () {
            // this.twilioStatus = 'Connecting to video call...';
            // this.isTwilioStarted = true;

            if (this.consultationId != null) {
                // this.axios.get('Consultation/GetTwilioRoom', {
                //     'params': {
                //         'consultationId': this.consultationId
                //     }
                // }).then(({
                //     data
                // }) => {
                //     this.twilioToken = data.data.t;
                //     this.twilioRoomName = data.data.n;

                //     this.$nextTick(() => {
                //         this.$refs.twilioVideo.startTwilio();
                //     });
                // })
                //     .catch(() => {
                //         this.isTwilioStarted = false;
                //     });

                this.axios.get('Consultation/GetVideoCallDetails', {
                    'params': {
                        'consultationId': this.consultationId
                    }
                }).then(({ data }) => {
                    this.zoomToken = data.data.token;
                    this.zoomParticipantName = data.data.participantName;
                    this.zoomSessionName = data.data.sessionName;
                    this.zoomSessionKey = data.data.sessionKey;

                    this.$nextTick(() => {
                        this.$refs.zoomVideo.initialize();
                    });
                });
            }
        },
        endVideoCall () {
            this.$refs.zoomVideo.endCall();

            // if (this.isTwilioJoined) {
            //     return this.axios.get('Consultation/EndTwilioSession', {
            //         'params': {
            //             'consultationId': this.consultationId
            //         }
            //     }).finally(() => {
            //         this.isTwilioJoined = false;
            //         return new Promise((resolve, reject) => {
            //             resolve();
            //         });
            //     });
            // } else {
            //     return new Promise((resolve, reject) => {
            //         resolve();
            //     });
            // }
        },
        validatePrescriptionValidDays () {
            return this.$validator.validateAll('prescription-valid-days');
        },
        consentViewConsultationHistories () {
            this.consent.isAllowedViewConsultationHistories = true;

            this.axios.post('ConsentService/GetConsentConsultationHistories', {
                'gi': this.consent.userId,
                'si': this.consent.sessionId
            }).then(({ data }) => {
                this.consultationList = data.data.map((consultation) => ({
                    'id': consultation.consultationId,
                    'date': consultation.datetime ? moment(consultation.datetime).format('DD/MM/YYYY') : null,
                    'time': consultation.datetime ? moment(consultation.datetime).format('hh:mm A') : null,
                    'doctorName': consultation.doctorName ? consultation.doctorName : '-',
                    'type': consultation.type,
                    'icd': consultation.icdCodes
                }));
            }).catch(() => {
                this.consent.isAllowedViewConsultationHistories = false;
            });
        },
        consentViewMedicalReports () {
            this.consent.isAllowedViewMedicalReports = true;

            this.axios.post('ConsentService/GetConsentMedicalReports', {
                'gi': this.consent.userId,
                'si': this.consent.sessionId
            }).then(({ data }) => {
                this.uploadedReports = data.data.map((report) => ({
                    'date': convertToUserReadableDate(report.ud),
                    'reportType': report.rt,
                    'reportId': report.ri
                }));
            }).catch(() => {
                this.consent.isAllowedViewMedicalReports = false;
            });
        },
        getConsultationLink (consultationType) {
            if (consultationType === 1) {
                return 'doctor-consultation-detail';
            } else if (consultationType === 2) {
                return 'doctor-consultation-no-pharmacy-detail';
            } else {
                return 'clinic-past-consultation-details';
            }
        },
        closeWindow () {
            window.close();
        },
        onZoomConnected () {
            this.zoomConnected = true;
            this.zoomStatus = 'Video call connected. Waiting for patient to join.';
        },
        onZoomEnded () {
            this.zoomEnded = true;
            this.zoomStatus = 'Video call ended.';
        },
        onZoomUserConnected () {
            this.zoomStatus = 'Patient connected to video call.';
        }
    }
};

</script>

<style scoped>
    #consultation-container {
        min-height: calc(710px - 64px - 24px);
        height: calc(100vh - 64px - 24px); /* Screen size minus footer and header */

        min-width: calc(1366px - 250px); /* 250px = Sidebar width */
    }

    #consultation-details {
        border-bottom: 1px solid grey;
        padding-top: 5px;
    }

    #consultation-details button {
        font-size: 12px;
        padding: 5px;
    }

    #consultation-fields {
        /* background: lightgreen; */
    }

    #first-col-wrapper {
        border-right: 0.5px solid grey;
        flex-basis: 0;
    }

    #second-col-wrapper {
        border-left: 0.5px solid grey;
        flex-basis: 0;
    }

    #section-1 {
        border-bottom: 0.5px solid grey;
        flex-basis: 0;
        padding: 5px;
        font-size: 14px;
    }

    #section-1 .label {
        width: 120px;
    }

    #section-1 textarea {
        font-size: 11px;
    }

    #section-2 {
        border-top: 0.5px solid grey;
        flex-basis: 0;
        padding: 5px;
        font-size: 14px;
    }

    #section-2 .small {
        /* width: 50px; */
        font-size: 12px;
        padding: 5px;
    }

    #section-2 input {
        font-size: 14px;
    }

    #section-2 .unit {
        font-size: 12px;
    }

    #section-2 textarea {
        font-size: 12px;
    }

    #section-3 {
        font-size: 14px;
        border-bottom: 0.5px solid grey;
        flex-basis: 0;
        padding: 5px;
    }

    #section-3 #prescription {
        font-size: 11px;
    }

    #section-3 #prescription input {
        padding: 0 5px 0 5px;
        font-size: 11px;
        width: 40px;
    }

    #section-4 {
        border-top: 0.5px solid grey;
        flex-basis: 0;
        padding: 5px;
        font-size: 14px;
        max-height: 50%;
    }

    #section-4 textarea {
        font-size: 11px;
    }

    /* #section-4 .btn {
        margin-top: 10px;
        width: 200px;
    } */

    .search-icon {
        color: #009344;
        display: none; /* Remove when working on maginfying function */
    }

    .search-icon:hover {
        cursor: pointer;
    }
</style>
